import store from '@/store'

const helper = {
  getDescuento: (pagoId) => {
    if (pagoId) {
      return store.getters['App/data'].Descuentos.filter(d => d.FPagoId === pagoId)[0]
    }
  },
  existeCupon: () => {
    return store.getters['App/data'].Descuentos.filter(d => d.CodigoCupon === 'CodigoCupon').length > 0
  },
  precioConDescuento (product) {
    const precio = product.PrecioUnitario || product.precio || product.totalPrice
    const { GrupoDescuento, Descuentos } = product
    if (GrupoDescuento) {
      if (GrupoDescuento && GrupoDescuento.Cantidad > -1) {
        /* console.log(product)
        const productosGrupo = store.getters['Carrito/getItems'].filter(p => p.GrupoDescuento.GrupoId === GrupoDescuento.GrupoId && product.id !== p.id)
        const cantidadGrupo = productosGrupo.reduce((a, b) => a + b.cant, 0) + product.cant
        productosGrupo.forEach(e => {
          store.dispatch('Carrito/editItem', {
            id: e.productId,
            PorcentajeDesct: GrupoDescuento.PorcentajeDesct,
            applyDiscoint: cantidadGrupo >= GrupoDescuento.Cantidad
          })
        })
        console.log(productosGrupo) */
        // Si GrupoDescuento requiere cantidad mínima, continuar revisando Descuentos
        // No retornar aquí, dejar que evalúe los descuentos individuales
      } else if (GrupoDescuento && GrupoDescuento.Cantidad === -1) {
        // TipoDescuento (P/I/C) indica el MÉTODO de cálculo del descuento
        const metodoCalculo = GrupoDescuento.TipoDescuento || 'P'

        if (metodoCalculo === 'I') {
          // Importe Fijo: restar el importe fijo
          return (precio - GrupoDescuento.PorcentajeDesct).toFixed(2)
        } else if (metodoCalculo === 'P') {
          // Porcentaje: cálculo tradicional
          return (precio - ((precio * GrupoDescuento.PorcentajeDesct) / 100)).toFixed(2)
        }
        // Tipo 'C' no aplica para productos individuales, solo para grupos por cantidad
        return precio.toFixed(2)
      }
    }
    // Buscar descuentos aplicables para productos individuales
    let descuentosParaEvaluar = Descuentos || []

    // Si el array de Descuentos está vacío pero existe GrupoDescuento, buscar en el store global
    if (descuentosParaEvaluar.length === 0 && GrupoDescuento && GrupoDescuento.GrupoId) {
      const descuentosGlobales = store.getters['App/data']?.Descuentos || []
      descuentosParaEvaluar = descuentosGlobales.filter(d => d.GrupoId === GrupoDescuento.GrupoId)
    }

    if (descuentosParaEvaluar.length > 0) {
      // Filtrar solo descuentos que aplican para productos individuales
      // (Cantidad === -1 y tipo diferente de 'C')
      const descuentosAplicables = descuentosParaEvaluar.filter(d => d.Cantidad === -1 && d.TipoDescuento !== 'C')

      if (descuentosAplicables.length > 0) {
        const descuento = descuentosAplicables[0]
        // TipoDescuento (P/I/C) indica el MÉTODO de cálculo del descuento
        const metodoCalculo = descuento.TipoDescuento || 'P'

        if (metodoCalculo === 'I') {
          // Importe Fijo: restar el importe fijo
          return precio - descuento.PorcentajeDesct
        } else if (metodoCalculo === 'P') {
          // Porcentaje: cálculo tradicional
          return precio - ((precio * descuento.PorcentajeDesct) / 100)
        }
      }
    }
    return precio
  },
  calcularDescuentos: (pagoId, neto) => {
    const calculoDescuentos = {
      descuentoTotal: 0.00,
      hayDescuentos: [],
      detalleDescuentos: []
    }
    const grupoPorCantidad = []
    const detalleProductoGrupo = []
    let montoDescuentoProductoGrupo = 0
    const grupoIdsEnCarrito = new Set()
    const productIdsEnCarrito = new Set()

    // --- PASO 1: Calcular descuentos de ítems (producto y grupo) y guardar monto + detalle ---
    store.getters['Carrito/getItems'].forEach(item => {
      if (item.GrupoDescuento && (item.descuentoPorGrupo || item.descuentoPorGrupoCantidad)) {
        grupoIdsEnCarrito.add(item.GrupoDescuento.GrupoId)
      }
      if (item.descuentoPorProducto && !item.descuentoPorGrupo && item.productId) {
        productIdsEnCarrito.add(item.productId)
      }
      if (item.descuentoPorGrupo && item.precio !== item.discoint) {
        const montoDescuento = item.cant * (item.precio - item.discoint)
        montoDescuentoProductoGrupo += montoDescuento
        detalleProductoGrupo.push({
          tipo: 'Grupo',
          descripcion: `${item.nombre} (×${item.cant})`,
          monto: parseFloat(montoDescuento.toFixed(2))
        })
      }

      if (item.descuentoPorGrupoCantidad) {
        if (!grupoPorCantidad.find(g => g === item.GrupoDescuento.GrupoId)) {
          grupoPorCantidad.push(item.GrupoDescuento.GrupoId)
          const productosGrupo = store.getters['Carrito/getItems'].filter(p =>
            p.GrupoDescuento && p.GrupoDescuento.GrupoId === item.GrupoDescuento.GrupoId
          )
          let cantidadTotal = 0
          let precioTotal = 0
          productosGrupo.forEach(p => {
            const precioUnitario = p.discoint || p.precio
            cantidadTotal += p.cant
            precioTotal += precioUnitario * p.cant
          })
          const metodoCalculo = item.GrupoDescuento.TipoDescuento || 'P'
          const cantidadRequerida = item.GrupoDescuento.Cantidad
          const promocionesCompletas = Math.floor(cantidadTotal / cantidadRequerida)

          if (promocionesCompletas > 0) {
            let descuentoPorCantidad = 0
            const productosEnPromo = cantidadRequerida * promocionesCompletas
            const precioProductosEnPromo = (precioTotal / cantidadTotal) * productosEnPromo

            if (metodoCalculo === 'C') {
              const precioTotalPromo = item.GrupoDescuento.PorcentajeDesct * promocionesCompletas
              descuentoPorCantidad = precioProductosEnPromo - precioTotalPromo
              detalleProductoGrupo.push({
                tipo: 'Promo',
                descripcion: `${productosEnPromo} × $${item.GrupoDescuento.PorcentajeDesct.toFixed(0)}`,
                monto: parseFloat(descuentoPorCantidad.toFixed(2))
              })
            } else if (metodoCalculo === 'I') {
              descuentoPorCantidad = item.GrupoDescuento.PorcentajeDesct
              detalleProductoGrupo.push({
                tipo: 'Desc. fijo',
                descripcion: `${productosEnPromo} productos`,
                monto: parseFloat(descuentoPorCantidad.toFixed(2))
              })
            } else {
              descuentoPorCantidad = (precioProductosEnPromo * item.GrupoDescuento.PorcentajeDesct) / 100
              detalleProductoGrupo.push({
                tipo: 'Promo',
                descripcion: `${productosEnPromo} prod. ${item.GrupoDescuento.PorcentajeDesct}%`,
                monto: parseFloat(descuentoPorCantidad.toFixed(2))
              })
            }
            montoDescuentoProductoGrupo += parseFloat(descuentoPorCantidad.toFixed(2))
          }
        }
      }

      if (item.descuentoPorProducto && !item.descuentoPorGrupo && item.precio !== item.discoint) {
        const montoDescuento = item.cant * (item.precio - item.discoint)
        montoDescuentoProductoGrupo += montoDescuento
        detalleProductoGrupo.push({
          tipo: 'Producto',
          descripcion: `${item.nombre} (×${item.cant})`,
          monto: parseFloat(montoDescuento.toFixed(2))
        })
      }
    })

    // --- PASO 2: Calcular descuentos forma de pago y cupón ---
    const descuentosGlobales = store.getters['App/data']?.Descuentos || []
    let descFormaPago = null
    let montoDescuentoFormaPago = 0
    let descCupon = null
    let montoDescuentoCupon = 0

    if (pagoId) {
      descFormaPago = descuentosGlobales.filter(d => d.FPagoId === pagoId)[0]
      if (descFormaPago) {
        const metodoCalculo = descFormaPago.TipoDescuento || 'P'
        montoDescuentoFormaPago = metodoCalculo === 'I' ? descFormaPago.PorcentajeDesct : (neto * descFormaPago.PorcentajeDesct) / 100
      }
    }

    descCupon = store.getters['App/appCupon']
    if (descCupon) {
      const metodoCalculo = descCupon.TipoDescuento || 'P'
      montoDescuentoCupon = metodoCalculo === 'I' ? descCupon.PorcentajeDesct : (neto * descCupon.PorcentajeDesct) / 100
    }

    // --- PASO 3: ¿Algún descuento que APLICA al carrito (por grupo o producto) está marcado no acumulable? ---
    const noAcumulable = (d) => d.NoAcumulable === true || d.noAcumulable === true
    const aplicaAlCarrito = (d) => {
      const grupoAplica = d.GrupoId != null && d.GrupoId > 0 && grupoIdsEnCarrito.has(d.GrupoId)
      const productoAplica = d.ProductoId != null && d.ProductoId > 0 && productIdsEnCarrito.has(d.ProductoId)
      return grupoAplica || productoAplica
    }
    const hayDescuentoNoAcumulableProductoGrupo = montoDescuentoProductoGrupo > 0 &&
      descuentosGlobales.some(d => aplicaAlCarrito(d) && noAcumulable(d))

    const noAcumulableFormaPago = descFormaPago ? (descFormaPago.NoAcumulable === true) : false
    const noAcumulableCupon = descCupon ? (descCupon.NoAcumulable === true) : false

    // Candidatos: cada uno con { clave, monto, noAcumulable, detalle, hayDescuentosLabel }
    const candidatos = [
      {
        clave: 'ProductoGrupo',
        monto: parseFloat(montoDescuentoProductoGrupo.toFixed(2)),
        noAcumulable: hayDescuentoNoAcumulableProductoGrupo,
        detalle: detalleProductoGrupo,
        hayDescuentosLabel: detalleProductoGrupo.length > 0 ? ['ProductoGrupo'] : []
      },
      {
        clave: 'FormaPago',
        monto: parseFloat(montoDescuentoFormaPago.toFixed(2)),
        noAcumulable: noAcumulableFormaPago,
        detalle: descFormaPago
          ? [{
              tipo: 'Forma de pago',
              descripcion: (descFormaPago.TipoDescuento || 'P') === 'I' ? 'Desc. fijo' : `${descFormaPago.PorcentajeDesct}%`,
              monto: parseFloat(montoDescuentoFormaPago.toFixed(2))
            }]
          : [],
        hayDescuentosLabel: ['FormaPago']
      },
      {
        clave: 'Cupon',
        monto: parseFloat(montoDescuentoCupon.toFixed(2)),
        noAcumulable: noAcumulableCupon,
        detalle: descCupon
          ? [{
              tipo: 'Cupón',
              descripcion: (descCupon.TipoDescuento || 'P') === 'I' ? 'Desc. fijo' : `${descCupon.PorcentajeDesct}%`,
              monto: parseFloat(montoDescuentoCupon.toFixed(2))
            }]
          : [],
        hayDescuentosLabel: ['Cupon']
      }
    ]

    const conMonto = candidatos.filter(c => c.monto > 0)
    const algunNoAcumulable = conMonto.some(c => c.noAcumulable)
    // Solo elegir uno cuando hay conflicto: 2 o más descuentos aplicables y al menos uno es no acumulable
    const debeElegirSoloUno = conMonto.length >= 2 && algunNoAcumulable

    if (debeElegirSoloUno) {
      // Aplicar solo el descuento que más le conviene al usuario (mayor monto)
      const elegido = conMonto.reduce((best, c) => (c.monto > best.monto ? c : best), conMonto[0])
      calculoDescuentos.descuentoTotal = elegido.monto
      calculoDescuentos.detalleDescuentos = elegido.detalle
      if (elegido.clave === 'ProductoGrupo') {
        calculoDescuentos.hayDescuentos = elegido.hayDescuentosLabel
      } else {
        calculoDescuentos.hayDescuentos = [elegido.clave === 'FormaPago' ? 'FormaPago' : 'Cupon']
      }
    } else {
      // Acumulables: sumar todos los que tengan monto > 0
      conMonto.forEach(c => {
        calculoDescuentos.descuentoTotal += c.monto
        calculoDescuentos.detalleDescuentos.push(...c.detalle)
        if (c.clave === 'ProductoGrupo') calculoDescuentos.hayDescuentos.push(...c.hayDescuentosLabel)
        else calculoDescuentos.hayDescuentos.push(c.clave === 'FormaPago' ? 'FormaPago' : 'Cupon')
      })
    }

    return calculoDescuentos
  }
}

export default helper
